import type { SortColumn } from "~/core/types/common.type";

import type { FilterItemType } from "~/lib/database/types";

export type GetOrgVisitorsParams = {
  q?: string;
  page: number;
  limit: number;
  filters?: FilterItemType[];
  sortings?: SortColumn[];
};

export type OrgVisitors = {
  serial: number;
  id: string;
  company_id: string | null;
  company_type: string[] | null;
  is_new: boolean;
  company_name: string;
  company_domain: string;
  company_logo: string;
  visitor_count: number;
  session_count: number;
  last_visited_at: Date;
  first_visited_at: Date;
  page_visit_count: number;
  intent_score: number;
  daily_visits: Array<{ visit_count: number; visit_date: Date }>;
};

export type VisitedPage = {
  page_url: string;
  page_title: string | null;
  total_visit_count: number;
  last_interaction: string;
};

export type VisitedCompanyInfo = {
  industry: string | null;
  founded_at: number | null;
  primary_location: string | null;
  estimated_annual_revenue: string | null;
  estimated_total_fund_raised: string | null;
  employee_size_range: string | null;
  linkedin_url: string | null;
  twitter_url: string | null;
  tech_stack: string[] | null;
  tech_categories: string[] | null;
};

export type DateRangePreset =
  | "today"
  | "yesterday"
  | "last_7_days"
  | "last_30_days"
  | "lifetime";

export enum VISITOR_COLUMN_NAME {
  COMPANY = "company",
  INTENT_SCORE = "intent_score",
  LAST_VISITED_AT = "last_visited_at",
  VISITOR_COUNT = "visitor_count",
  SESSION_COUNT = "session_count",
  COMPANY_TYPE = "company_type",
}
